import {CourseSearchPageProps} from "./types";
import {Card, Heading, Paragraph} from "@digdir/designsystemet-react";

export function CourseSearchPage({pageOfEvents, translations}: CourseSearchPageProps) {
    return (
        <section className="w-full flex flex-col gap-4">
            {pageOfEvents && pageOfEvents.length > 0 ? pageOfEvents.map((event) => (
                <Card
                    key={event.id}
                    className="flex flex-col gap-[7px] p-5.5 rounded-none border border-neutralNsf-subtle md:gap-2 md:p-6 xl:gap-[9px] xl:p-[27px]"
                    asChild>
                    <a href={event.url}>
                        <Card.Block>
                            <Heading level={2}>
                                {event.name}
                            </Heading>
                            <Paragraph>{event.intro}</Paragraph>
                        </Card.Block>
                    </a>
                </Card>
            )) : (
                <div className="w-full px-4 flex justify-center">
                    <Paragraph data-size="sm" className="!mb-0">
                        {translations.noResults}
                    </Paragraph>
                </div>
            )}
        </section>
    );
}